import { render, staticRenderFns } from "./AddAiAgent.vue?vue&type=template&id=6c9b84d7&scoped=true&"
import script from "./AddAiAgent.vue?vue&type=script&lang=js&"
export * from "./AddAiAgent.vue?vue&type=script&lang=js&"
import style0 from "./AddAiAgent.vue?vue&type=style&index=0&id=6c9b84d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9b84d7",
  null
  
)

export default component.exports